import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
//import {Helmet} from "react-helmet";
import API from '../api';
import Settings from '../constants/Settings';

import {
  Box,
} from 'grommet';

import Content from '../utils/RenderContent';
import Analytics from '../utils/Analytics';
import RenderHelmet from '../utils/RenderHelmet';
import PageWrap from "../components/PageWrap";
import NotFound from '../components/NotFound';

const Museum = (props) => {
    const { match, t, i18n } = props;
    const [content, setContent] = useState(false);

    useEffect(() => {
      Analytics.TrackPageView(window.location.pathname)
      loadContent()
    }, []);

    const loadContent = () => {
      API.getPageBySlug(i18n, 'museum').then( (res) => {
        var inlineContent = res.items[0];
        setContent(inlineContent);
      })
      .catch(console.error)
    }

    return (
      <Box id="page">
        <RenderHelmet content={content} match={match} t={t} i18n={i18n} />
        <PageWrap content={content}>
          <Content content={content} match={match} t={t} i18n={i18n} />
        </PageWrap>
      </Box>
    );
}

const PageTranslated = withTranslation("translations")(Museum);
export default PageTranslated
